import React, { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useToast } from '@/hooks/useToast';
import ToggleRow from '@/components/ToggleRow';
import SKCard from '@/components/UI/SKCard';
import { SIKKA_FAQS, SECTION_NAMES } from '@/data/faq';
import { copyToClickBoard } from '@/utils';
import { FAQS_PAGE } from '@/constants/route.const';
import LinkIcon from '@/public/assets/icons/link.svg';

export default function FAQ({ 
  list = SIKKA_FAQS, 
  showLength = Infinity, 
  isNotBlog = false, 
  initialLang = 'en',
  lang,
  classes = {}
}) {
  const router = useRouter();
  const toast = useToast();
  const currentLang = lang || initialLang;

  // Group FAQs by section
  const groupedFaqs = useMemo(() => {
    const groups = {};
    const faqs = list.slice(0, showLength);
    faqs.forEach(faq => {
      const section = faq.sectionKey;
      if (!groups[section]) {
        groups[section] = [];
      }
      groups[section].push(faq);
    });
    return groups;
  }, [list, showLength]);

  return (
    <div className={classes.FaqList}>
      {Object.keys(groupedFaqs).map(sectionKey => (
        <div key={sectionKey}>
          {SECTION_NAMES[sectionKey] && (
            <h2 className={classes.sectionTitle}>
              {SECTION_NAMES[sectionKey][currentLang]}
            </h2>
          )}
          {groupedFaqs[sectionKey].map(d => (
            <SKCard className={classes.card} id={`${d.key}`} key={d.key}>
              <ToggleRow
                key={d.key}
                header={
                  <div className={classes.rowHeader}>
                    {!isNotBlog && (
                      <LinkIcon
                        className={classes.linkIcon}
                        onClick={() => {
                          const FAQ_LINK = `${window.location.origin}${FAQS_PAGE}?lang=${currentLang === 'id' ? 'in' : currentLang}#${d.key}`;

                          router.replace(`${FAQS_PAGE}#${d.key}`);

                          if (copyToClickBoard(FAQ_LINK)) {
                            toast({ title: 'Link copied!', key: 'faq-link' });
                          }
                        }}
                      />
                    )}
                    {d[currentLang]?.title || d.en?.title}
                  </div>
                }
                body={d[currentLang]?.desc || d.en?.desc}
                defaultOpen={`#${d.key}` === `#${router.asPath.split('#')[1]}`}
              />
            </SKCard>
          ))}
        </div>
      ))}
    </div>
  );
}
